import { render } from "./phoneVerify.vue?vue&type=template&id=24f39ebc&scoped=true"
import script from "./phoneVerify.vue?vue&type=script&lang=js"
export * from "./phoneVerify.vue?vue&type=script&lang=js"

import "./phoneVerify.vue?vue&type=style&index=0&id=24f39ebc&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f39ebc"]])

export default __exports__